import script from "./default.vue?vue&type=script&lang=ts&setup=true"
export * from "./default.vue?vue&type=script&lang=ts&setup=true"

import "./default.vue?vue&type=style&index=0&id=9166b15e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9166b15e"]])

export default __exports__